module.exports = __webpack_public_path__ + "img/video-icon.3624c45f.svg";